export interface TorchCaptureCopy {
  readonly shutter: string;
  readonly cancel: string;
  readonly torchOn: string;
  readonly torchOff: string;
  readonly starting: string;
  readonly turningLightOn: string;
  readonly capturing: string;
}

export const DEFAULT_TORCH_CAPTURE_COPY: TorchCaptureCopy = {
  shutter: 'Take photo',
  cancel: 'Cancel',
  torchOn: 'Turn light on',
  torchOff: 'Turn light off',
  starting: 'Starting camera',
  turningLightOn: 'Turning light on',
  capturing: 'Taking photo'
};

export type TorchUnavailableReason = 'no-camera' | 'permission-denied' | 'camera-error';
